<template>
  <div class="prize-name" :class="getClass">{{ name }}</div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    pos: Number
  },
  computed: {
    getClass () {
      return [
        `prize-name-${this.$bus.shopType}`,
        this.pos === 2 ? 'prize-name-t' : 'prize-name-no-t'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.prize-name {
  position: absolute;
  @include px2res(top, 100);
  @include flexrc;
  @include px2res(padding, 2);
  @include px2res(font-size, 20);
  font-family: $main-font-family;
  white-space: nowrap;
  z-index: 10;

  &.bought-filter {
    filter: grayscale(100%);
  }

  &.prize-name-no-t {
    @include px2res(left, 60);
  }

  &.prize-name-t {
    @include px2res(right, 60);
  }

  &.prize-name-food {
    background-color: #2D160A;
    @include px2res(border-width, 4);
    border-style: solid;
    border-color: #00A3C5;
  }

  &.prize-name-fishing {
    background-color: #081418;
    @include px2res(border-width, 4);
    border-style: solid;
    border-color: #BF2B7B;
  }

  &.prize-name-shoot {
    background-color: #1D0D26;
    @include px2res(border-width, 4);
    border-style: solid;
    // border-color: #308A46;
    border-color: #fcb713;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business-base/prize-name/index.vue